export const pressureVesselProducts = [
  {
    id: 'frp-pressure-vessel',
    title: 'FRP Pressure Vessel',
    category: 'RO & UF Pressure Vessel',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/4c5833d991f8217ba0f211b65b8439a7.jpg',
    shortDescription: 'High-quality FRP pressure vessels for RO and UF membrane applications with various pressure ratings and configurations.',
    description: 'Professional FRP pressure vessels designed for reverse osmosis and ultrafiltration membrane systems.',
    longDescription: 'Our FRP pressure vessels are manufactured using high-quality fiberglass reinforced plastic materials, designed to accommodate standard membrane elements in various sizes. These vessels offer excellent chemical resistance, durability, and cost-effectiveness for water treatment applications.',
    features: [
      'Multiple pressure ratings: 300psi, 450psi, 600psi, 1000psi, 1200psi',
      'Available in 2.5", 4", and 8" membrane element sizes',
      'End entry and side entry configurations',
      'Fiberglass reinforced plastic construction',
      'Wide operating temperature range: -10°C to 49°C',
      'Excellent chemical resistance (pH 3-11)',
      '100% QA tested with 1.5x design hydraulic pressure',
      'ASME compliant design'
    ],
    applications: [
      'Reverse osmosis systems',
      'Ultrafiltration systems',
      'Water treatment plants',
      'Industrial water processing',
      'Desalination systems',
      'Wastewater treatment'
    ],
    specifications: {
      'FRPMV25E (End Entry)': {
        'Max. design pressure rating': '300psi, 1000Psi, 1200Psi',
        'Model': '2514, 2521, 2540',
        'Accommodates': 'Standard make 2.5" Membrane Element',
        'Operating Temp Range': '-10°C to 49°C',
        'Feed / Concentrate port': '1/4" female',
        'Permeate port': '1/4" female',
        'Operating pH Range': '3 — 11',
        'Cleaning pH Range': '2 — 12 (less than 30 minutes)',
        'Test pressure': '100% QA test with 1.5x design hydraulic pressure, ASME: 1.1x Design Pressure'
      },
      'FRPMV40E (End Entry)': {
        'Max. design pressure rating': '300psi, 450psi, 600psi, 1000psi, 1200psi',
        'Model': '4021, 4040-1W, 4040-2W, 4040-3W, 4040-4W',
        'Accommodates': 'Standard make 4" Membrane Element',
        'Operating Temp Range': '-10°C to 49°C',
        'Feed / Concentrate port': '3/4" female',
        'Permeate port': '1/2" female',
        'Operating pH Range': '3 — 11',
        'Cleaning pH Range': '2 — 12 (less than 30 minutes)',
        'Test pressure': '100% QA test with 1.5x design hydraulic pressure, ASME: 1.1x Design Pressure'
      },
      'FRPMV40S (Side Entry)': {
        'Max. design pressure rating': '300psi, 450psi, 600psi, 1000psi, 1200psi',
        'Model': '4021, 4040-1W, 4040-2W, 4040-3W, 4040-4W',
        'Accommodates': 'Standard make 4" Membrane Element',
        'Operating Temp Range': '-10°C to 49°C',
        'Feed / Concentrate port': '1" coupling',
        'Permeate port': '1/2", 3/4" female',
        'Operating pH Range': '3 — 11',
        'Cleaning pH Range': '2 — 12 (less than 30 minutes)',
        'Test pressure': '100% QA test with 1.5x design hydraulic pressure, ASME: 1.1x Design Pressure'
      },
      'FRPMV80E (End Entry)': {
        'Max. design pressure rating': '300psi, 450psi, 600psi, 1000psi, 1200psi',
        'Model': '8040-1W, 8040-2W, 8040-3W, 8040-4W, 8040-5W, 8040-6W, 8040-7W, 8040-8W',
        'Accommodates': 'Standard make 8" Membrane Element',
        'Operating Temp Range': '-10°C to 49°C',
        'Feed / Concentrate port': '1 1/2" coupling',
        'Permeate port': '1" female',
        'Operating pH Range': '3 — 11',
        'Cleaning pH Range': '2 — 12 (less than 30 minutes)',
        'Test pressure': '100% QA test with 1.5x design hydraulic pressure, ASME: 1.1x Design Pressure'
      },
      'FRPMV80S (Side Entry)': {
        'Max. design pressure rating': '300psi, 450psi, 600psi, 1000psi, 1200psi',
        'Model': '8040-1W, 8040-2W, 8040-3W, 8040-4W, 8040-5W, 8040-6W, 8040-7W, 8040-8W',
        'Accommodates': 'Standard make 8" Membrane Element',
        'Operating Temp Range': '-10°C to 49°C',
        'Feed / Concentrate port': '1 1/2" coupling',
        'Permeate port': '1" female',
        'Operating pH Range': '3 — 11',
        'Cleaning pH Range': '2 — 12 (less than 30 minutes)',
        'Test pressure': '100% QA test with 1.5x design hydraulic pressure, ASME: 1.1x Design Pressure'
      },
      'FRP DTRO/STRO Vessel Housing': {
        'Application': 'DTRO / STRO FRP housing for disc tube/spacer tube RO membrane module systems used for landfill leachate treatment, high-salt water treatment and difficult treatment water',
        'Material': 'Fiberglass and epoxy',
        'Process': 'Winded',
        'Pressure rate (Bar)': '75 Bar, 90 bar, 120 bar, 150 Bar, 200 Bar optional',
        'Available height': '945mm, 1000mm, 1150mm, 1200mm, 1250mm or customized',
        'Operating temperature': '-7 °C ~ 49 °C',
        'Color': 'Natural or customized'
      }
    },
    technicalData: {
      'High Flow FRP Filter Housing (End Entry)': [
        { model: 'W80E150-20', entryWay: 'End', maxPressure: '150Psi', dia: '8"', length: '20"', capacity: '15-25', elementQty: '1pc' },
        { model: 'W80E150-40', entryWay: 'End', maxPressure: '150Psi', dia: '8"', length: '40"', capacity: '30-50', elementQty: '1pc' },
        { model: 'W80E150-60', entryWay: 'End', maxPressure: '150Psi', dia: '8"', length: '60"', capacity: '50-70', elementQty: '1pc' }
      ],
      'High Flow FRP Filter Housing (Side Entry)': [
        { model: 'W80S150-20', entryWay: 'Side', maxPressure: '150Psi', dia: '8"', length: '20"', capacity: '15-25', elementQty: '1pc' },
        { model: 'W80S150-40', entryWay: 'Side', maxPressure: '150Psi', dia: '8"', length: '40"', capacity: '30-50', elementQty: '1pc' },
        { model: 'W80S150-60', entryWay: 'Side', maxPressure: '150Psi', dia: '8"', length: '60"', capacity: '50-70', elementQty: '1pc' }
      ]
    }
  },
  {
    id: 'ss-pressure-vessel',
    title: 'SS Pressure Vessel',
    category: 'RO & UF Pressure Vessel',
    image: 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/9baf89d166ebf0f794b3566b13049c6d.png',
    shortDescription: 'Premium stainless steel pressure vessels for RO and UF membrane applications with superior corrosion resistance and durability.',
    description: 'Professional stainless steel pressure vessels designed for reverse osmosis and ultrafiltration membrane systems.',
    longDescription: 'Our SS pressure vessels are manufactured using high-grade stainless steel materials (SS316L or SS#304), designed to accommodate standard membrane elements in various sizes. These vessels offer exceptional corrosion resistance, superior durability, and long-term reliability for demanding water treatment applications.',
    features: [
      'Premium stainless steel construction (SS316L or SS#304)',
      'Available in 2.5", 4", and 8" membrane element sizes',
      'End entry and side entry configurations',
      'Seamless or seamed vessel tube options',
      'ABS plastic or stainless steel end caps',
      'Multiple pressure ratings up to 1000PSI',
      'Wide operating temperature range: 10°C to 49°C',
      'Standard and ASME compliant testing',
      'Superior corrosion resistance'
    ],
    applications: [
      'High-pressure reverse osmosis systems',
      'Industrial ultrafiltration systems',
      'Corrosive water treatment applications',
      'Food and beverage processing',
      'Pharmaceutical water treatment',
      'Chemical processing industries'
    ],
    specifications: {
      'SSMV25E (End Entry Design)': {
        'Accommodates': 'Standard make 2.5" Membrane Element',
        'Vessel material': 'SS316L or SS#304',
        'Vessel tube': 'Seamless',
        'End cap': 'ABS plastic',
        'Operating Temp Range': '10°C to 49°C',
        'Feed / Concentrate port': '3/8" or 1/4" thread',
        'Permeate port': '3/8" or 1/4" thread',
        'Test pressure Standard': '1.5x Design Pressure',
        'Test pressure ASME': '1.1x Design Pressure'
      },
      'SSMV40E (End Entry Design)': {
        'Accommodates': 'Standard make 4" Membrane Element',
        'Vessel material': 'SS316L or SS#304',
        'Vessel tube': 'Seamless or Seamed',
        'End cap': 'ABS plastic or Stainless steel',
        'Operating Temp Range': '10°C to 49°C',
        'Feed / Concentrate port': '3/4" or 1/2" thread',
        'Permeate port': '1/2" thread',
        'Test pressure Standard': '1.5x Design Pressure',
        'Test pressure ASME': '1.1x Design Pressure'
      },
      'SSMV40S (Side Entry Design)': {
        'Accommodates': 'Standard make 4" Membrane Element',
        'Vessel material': 'SS316L or SS#304',
        'Vessel tube': 'Seamless or Seamed',
        'End cap': 'ABS plastic or Stainless steel',
        'Operating Temp Range': '10°C to 49°C',
        'Feed / Concentrate port': '3/4" thread',
        'Permeate port': '1/2" thread',
        'Test pressure Standard': '1.5x Design Pressure',
        'Test pressure ASME': '1.1x Design Pressure'
      },
      'SSMV80E (End Entry Design)': {
        'Accommodates': 'Standard make 8" Membrane Element',
        'Vessel material': 'SS316L or SS#304',
        'Vessel tube': 'Seamless',
        'End cap': 'Stainless steel',
        'Operating Temp Range': '10°C to 49°C',
        'Feed / Concentrate port': '1 1/2" coupling',
        'Permeate port': '1" thread',
        'Test pressure Standard': '1.5x Design Pressure',
        'Test pressure ASME': '1.1x Design Pressure'
      },
      'SSMV80S (Side Entry Design)': {
        'Accommodates': 'Standard make 8" Membrane Element',
        'Vessel material': 'SS316L or SS#304',
        'Vessel tube': 'Seamless',
        'End cap': 'Stainless steel',
        'Operating Temp Range': '10°C to 49°C',
        'Feed / Concentrate port': '1 1/2" coupling',
        'Permeate port': '1" thread',
        'Test pressure Standard': '1.5x Design Pressure',
        'Test pressure ASME': '1.1x Design Pressure'
      }
    },
    technicalData: {
      'SSMV25E Models': [
        { model: 'SSMV2540E-300-1W', designPressure: '300PSI', roModel: '2540', element: '1' },
        { model: 'SSMV2521E-300-1W', designPressure: '300PSI', roModel: '2521', element: '1' },
        { model: 'SSMV2514E-300-1W', designPressure: '300PSI', roModel: '2514', element: '1' }
      ],
      'SSMV40E Models': [
        { model: 'SSMV4040E-300-1W', designPressure: '300PSI', roModel: '4040', element: '1' },
        { model: 'SSMV4040E-300-2W', designPressure: '300PSI', roModel: '4040', element: '2' },
        { model: 'SSMV4040E-300-3W', designPressure: '300PSI', roModel: '4040', element: '3' },
        { model: 'SSMV4040E-300-4W', designPressure: '300PSI', roModel: '4040', element: '4' }
      ],
      'SSMV40S Models': [
        { model: 'SSMV4040S-300-1W', designPressure: '300PSI', roModel: '4040', element: '1' },
        { model: 'SSMV4040S-300-2W', designPressure: '300PSI', roModel: '4040', element: '2' },
        { model: 'SSMV4040S-300-3W', designPressure: '300PSI', roModel: '4040', element: '3' },
        { model: 'SSMV4040S-300-4W', designPressure: '300PSI', roModel: '4040', element: '4' }
      ],
      'SSMV80E Models': [
        { model: 'SSMV8040E-300-1W', designPressure: '300PSI', roModel: '8040', element: '1' },
        { model: 'SSMV8040E-300-2W', designPressure: '300PSI', roModel: '8040', element: '2' },
        { model: 'SSMV8040E-300-3W', designPressure: '300PSI', roModel: '8040', element: '3' },
        { model: 'SSMV8040E-300-4W', designPressure: '300PSI', roModel: '8040', element: '4' },
        { model: 'SSMV8040E-300-5W', designPressure: '300PSI', roModel: '8040', element: '5' },
        { model: 'SSMV8040E-300-6W', designPressure: '300PSI', roModel: '8040', element: '6' }
      ],
      'SSMV80S Models (300PSI)': [
        { model: 'SSMV8040S-300-1W', designPressure: '300PSI', roModel: '8040', element: '1' },
        { model: 'SSMV8040S-300-2W', designPressure: '300PSI', roModel: '8040', element: '2' },
        { model: 'SSMV8040S-300-3W', designPressure: '300PSI', roModel: '8040', element: '3' },
        { model: 'SSMV8040S-300-4W', designPressure: '300PSI', roModel: '8040', element: '4' },
        { model: 'SSMV8040S-300-5W', designPressure: '300PSI', roModel: '8040', element: '5' },
        { model: 'SSMV8040S-300-6W', designPressure: '300PSI', roModel: '8040', element: '6' }
      ],
      'SSMV80S Models (1000PSI)': [
        { model: 'SSMV8040S-1000-1W', designPressure: '1000PSI', roModel: '8040', element: '1' },
        { model: 'SSMV8040S-1000-2W', designPressure: '1000PSI', roModel: '8040', element: '2' },
        { model: 'SSMV8040S-1000-3W', designPressure: '1000PSI', roModel: '8040', element: '3' },
        { model: 'SSMV8040S-1000-4W', designPressure: '1000PSI', roModel: '8040', element: '4' },
        { model: 'SSMV8040S-1000-5W', designPressure: '1000PSI', roModel: '8040', element: '5' },
        { model: 'SSMV8040S-1000-6W', designPressure: '1000PSI', roModel: '8040', element: '6' }
      ]
    }
  }
];

export const pressureVesselProductsList = pressureVesselProducts;
export default pressureVesselProducts;